import stateFetch from './modules/fetchState';
import {bind} from './modules/bind';
import {toggleDisabled} from './components/toggleDisabled';
import {phoneNumber} from './components/phoneNumber';
import {printer} from './components/printer';
import {unsavedChanges} from './components/unsavedChanges';
import {focusInvalidControl} from './components/focusInvalidControl';
import {copyToClipboard} from './components/copyToClipboard';
import {subdomainFromString} from './components/subdomainFromString.js';
import {dropdown} from './components/dropdown.js';
import {submitOnChange} from './components/submitOnChange.js';
import {eventHandler} from './components/eventHandler.js';

/* Global */
stateFetch();
unsavedChanges();
focusInvalidControl();

/* MFA recovery codes */
copyToClipboard();
printer();

/* Input components */
phoneNumber();
toggleDisabled(); /* Password visibility toggle */

/* Autocomplete Kinde business */
subdomainFromString();
eventHandler();

/* Preview mode - ideally remove */
submitOnChange();
dropdown();

// NOTE: Should always come last to bind all other JS
bind();
